(function () {
  if (customElements.get('range-can-offer')) return;

  // Reviews band on range-can PDPs: show every quote at once (grid / swipe row), not a one-card carousel.
  function staticQuotes() {
    if (!document.querySelector('.rco-page')) return;
    document.querySelectorAll('.testimonials-wrapper--buyer-card testimonials-component').forEach((component) => {
      const previews = component.querySelector('.testimonial__previews');
      if (!previews || previews.children.length < 2) return;
      const settle = () => {
        const nav = component.flickityNav || (window.Flickity && window.Flickity.data && window.Flickity.data(previews));
        if (nav && typeof nav.destroy === 'function') {
          nav.destroy();
          component.flickityNav = null;
        }
        if (!previews.classList.contains('flickity-enabled') && !previews.classList.contains('rco-quotes')) previews.classList.add('rco-quotes');
      };
      settle();
      new MutationObserver(settle).observe(previews, { attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', staticQuotes);
  else staticQuotes();

  customElements.define('range-can-offer', class RangeCanOffer extends HTMLElement {
    constructor() {
      super();
      this.state = {
        variant: null,
        delivery: 'onetime',
        engraving: {
          enabled: false,
          text: ''
        },
        busy: false,
        double: false
      };
      this.redirectUrl = this.normalizeRedirectUrl(this.dataset.redirectUrl);
      this.hasSellingPlan = this.dataset.hasSellingPlan === 'true';
      this.sellingPlanFrequency = Number(this.dataset.sellingPlanFrequency) || (this.hasSellingPlan ? 90 : null);
      this.rangeRestockVariantId = this.dataset.rangeRestockVariantId || '51411858424103';
      this.stockRestockVariantId = this.dataset.stockRestockVariantId || '51411858456871';
      this.primaryCta = this.dataset.primaryCta || 'Personalize My Range Can';
      this.quarterlyCta = this.dataset.quarterlyCta || '';
    }

    connectedCallback() {
      this.normalizeRenderedMarkup();
      this.bindMediaThumbs();
      this.bindPackageOptions();
      this.bindDeliveryOptions();
      this.bindEngravingOptions();
      this.bindPersonalizationOptions();
      this.bindButtons();
      this.bindDoubleToggle();
      this.bindFaq();
      this.bindExternalBuy();
      this.bindCaliberStrip();
      this.initSticky();
      this.syncInitialState();
      this.updateView();
    }

    normalizeRenderedMarkup() {
      this.querySelectorAll('[data-package-option]').forEach((option) => {
        const price = option.querySelector('[data-package-price]') ||
          option.querySelector('.rco-package__price strong');
        if (price && !price.hasAttribute('data-package-price')) {
          price.setAttribute('data-package-price', '');
        }

        const compare = option.querySelector('[data-package-compare]') ||
          option.querySelector('.rco-package__price s');
        if (compare) {
          const compareText = compare.textContent.trim();
          if (!option.dataset.comparePriceFormatted && compareText) {
            option.dataset.comparePriceFormatted = compareText;
          }

          if (!compare.hasAttribute('data-package-compare')) {
            compare.setAttribute('data-package-compare', '');
          }
        }
      });

      const deliveryGrid = this.querySelector('.rco-delivery-grid');
      const deliveryStep = deliveryGrid?.closest('.rco-step');
      if (deliveryStep) {
        deliveryStep.classList.add('rco-step--delivery');

        const heading = deliveryStep.querySelector('.rco-step__head h2');
        if (heading && heading.textContent.trim().toLowerCase() === 'choose delivery') {
          heading.textContent = 'Delivery';
        }

        const quarterly = deliveryStep.querySelector('[data-delivery-option][data-delivery="quarterly"]');
        if (quarterly && this.hasSellingPlan) {
          const title = quarterly.querySelector('strong');
          if (title && /^(restock quarterly|quarterly restock)$/i.test(title.textContent.trim())) {
            title.textContent = 'Quarterly';
          }

          const detail = quarterly.querySelector('span:not(.rco-delivery__mark)');
          if (detail && /90\s*days/i.test(detail.textContent)) {
            detail.textContent = 'Every 90 days';
          }
        }
      }
    }

    bindMediaThumbs() {
      const stage = this.querySelector('[data-media-stage-wrap]');

      this.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => this.selectMedia(thumb));
      });

      this.querySelectorAll('[data-media-prev], [data-media-next]').forEach((button) => {
        button.addEventListener('click', () => {
          const direction = button.hasAttribute('data-media-prev') ? -1 : 1;
          this.selectAdjacentMedia(direction);
        });
      });

      if (stage) {
        stage.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.selectAdjacentMedia(event.key === 'ArrowLeft' ? -1 : 1);
        });

        let touchStartX = 0;
        let touchStartY = 0;

        stage.addEventListener('pointerdown', (event) => {
          touchStartX = event.clientX;
          touchStartY = event.clientY;
        });

        stage.addEventListener('pointerup', (event) => {
          const deltaX = event.clientX - touchStartX;
          const deltaY = event.clientY - touchStartY;
          if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY)) return;
          this.selectAdjacentMedia(deltaX > 0 ? -1 : 1);
        });
      }

      this.updateMediaStatus();
    }

    selectAdjacentMedia(direction) {
      const thumbs = Array.from(this.querySelectorAll('[data-media-thumb]'));
      if (!thumbs.length) return;

      const currentIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-selected')));
      const nextIndex = (currentIndex + direction + thumbs.length) % thumbs.length;
      this.selectMedia(thumbs[nextIndex]);
    }

    selectMedia(thumb) {
      if (!thumb) return;

      const desktopImage = this.querySelector('[data-media-stage-desktop]');
      const mobileSource = this.querySelector('[data-media-stage-mobile]');
      const stage = this.querySelector('[data-media-stage-wrap]');
      const desktopSrc = thumb.dataset.desktopSrc || '';
      const mobileSrc = thumb.dataset.mobileSrc || desktopSrc;
      const alt = thumb.dataset.alt || '';
      const fit = thumb.dataset.fit || 'cover';

      if (desktopImage && desktopSrc) {
        desktopImage.src = desktopSrc;
        desktopImage.alt = alt;
      }

      if (mobileSource && mobileSrc) {
        mobileSource.srcset = mobileSrc;
      }

      this.querySelectorAll('[data-media-thumb]').forEach((button) => {
        const active = button === thumb;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (stage) {
        stage.dataset.mediaFit = fit;
        stage.dataset.mediaLabel = thumb.dataset.mediaLabel || '';
      }
      this.updateMediaStatus(thumb);
    }

    updateMediaStatus(activeThumb) {
      const status = this.querySelector('[data-media-status]');
      if (!status) return;

      const thumbs = Array.from(this.querySelectorAll('[data-media-thumb]'));
      if (!thumbs.length) return;

      const active = activeThumb || thumbs.find((thumb) => thumb.classList.contains('is-selected')) || thumbs[0];
      const label = active.dataset.mediaLabel || 'Product';
      const index = Number(active.dataset.mediaIndex || thumbs.indexOf(active) + 1);
      const stage = this.querySelector('[data-media-stage-wrap]');
      if (stage) {
        stage.dataset.mediaFit = active.dataset.fit || stage.dataset.mediaFit || 'cover';
        // Phones: the squared progress bar on the photo stands in for the thumb strip.
        stage.style.setProperty('--rco-slide', String(index));
        stage.style.setProperty('--rco-slides', String(thumbs.length));
        // Desktop: the frame takes the shape of the photo in it (square hero, 3:2 slides), so a
        // wide slide never sits in a square of white. CSS only applies --rco-ar at 750px+.
        const img = stage.querySelector('img');
        const fitFrame = () => {
          if (img && img.naturalWidth && img.naturalHeight) {
            stage.style.setProperty('--rco-ar', String(img.naturalWidth / img.naturalHeight));
          }
        };
        if (img) {
          if (img.complete) fitFrame();
          img.addEventListener('load', fitFrame, { once: true });
        }
      }
      status.textContent = `${label} image ${index} of ${thumbs.length}`;
    }

    bindPackageOptions() {
      const keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
      this.querySelectorAll('[data-package-option]').forEach((option) => {
        option.addEventListener('click', () => {
          // An explicit tier pick: the upgrade sheet will not re-ask the same question.
          if (!option.disabled && !this.state.busy) this.state.userPickedTier = true;
          this.selectPackage(option);
        });
        option.addEventListener('keydown', (event) => {
          if (keys[event.key]) {
            this.state.userPickedTier = true;
            // Radiogroup pattern: arrows move selection and focus to the next enabled tier.
            event.preventDefault();
            const options = Array.from(this.querySelectorAll('[data-package-option]:not(:disabled)'));
            const index = options.indexOf(option);
            if (index < 0 || !options.length) return;
            const next = options[(index + keys[event.key] + options.length) % options.length];
            this.selectPackage(next);
            next.focus();
            return;
          }
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          option.click();
        });
      });
    }

    bindDeliveryOptions() {
      this.querySelectorAll('[data-delivery-option]').forEach((option) => {
        option.addEventListener('click', () => this.selectDelivery(option));
        option.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          option.click();
        });
      });
    }

    bindEngravingOptions() {
      const engraving = this.querySelector('[data-engraving]');
      if (!engraving) return;

      const toggle = engraving.querySelector('[data-engraving-toggle]');
      const field = engraving.querySelector('[data-engraving-field]');
      const input = engraving.querySelector('[data-engraving-input]');
      if (!field || !input) return;

      if (toggle) {
        toggle.addEventListener('change', () => {
          const enabled = toggle.checked;
          if (!enabled) input.removeAttribute('aria-invalid');
          this.formatEngravingInput(input);
          this.state.engraving.enabled = enabled;
          this.state.engraving.text = this.normalizeEngravingText(input.value);
          this.syncPersonalizationInputs(input.value);
          engraving.classList.toggle('is-selected', enabled);
          field.hidden = !enabled;
          toggle.setAttribute('aria-expanded', enabled ? 'true' : 'false');
          if (!enabled) this.showError('');
          this.updateView();
        });
      } else {
        engraving.classList.add('is-selected');
        field.hidden = false;
        this.formatEngravingInput(input);
        this.state.engraving.text = this.normalizeEngravingText(input.value);
        this.state.engraving.enabled = true;
      }

      input.addEventListener('input', () => {
        this.formatEngravingInput(input);
        input.removeAttribute('aria-invalid');
        this.state.engraving.enabled = toggle ? toggle.checked : true;
        this.state.engraving.text = this.normalizeEngravingText(input.value);
        this.syncPersonalizationInputs(input.value);
        // One shared name: mirror it into the closing CTA's name field.
        document.querySelectorAll('[data-rco-final-engraving]').forEach((finalInput) => {
          if (finalInput.value !== input.value) finalInput.value = input.value;
        });
        this.showError('');
        this.updateView();
      });

      document.addEventListener('input', (event) => {
        const source = event.target;
        if (!source || !source.matches || !source.matches('[data-rco-final-engraving]')) return;
        const value = String(source.value || '').toUpperCase();
        if (input.value === value) return;
        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    bindPersonalizationOptions() {
      const inputs = Array.from(this.querySelectorAll('[data-personalization-input]'));
      if (!inputs.length) return;

      const syncFromInput = (source, enableWhenFilled = false) => {
        this.formatEngravingInput(source);
        const text = String(source.value || '');
        const normalizedText = this.normalizeEngravingText(text);

        inputs.forEach((input) => {
          if (input !== source && input.value !== text) input.value = text;
        });

        this.setEngravingFromPersonalization(text, enableWhenFilled && Boolean(normalizedText));
      };

      inputs.forEach((input) => {
        input.addEventListener('input', () => syncFromInput(input, true));
      });

      this.querySelectorAll('[data-personalization-apply]').forEach((control) => {
        control.addEventListener('click', () => {
          const input = inputs[0];
          if (input) syncFromInput(input, true);
        });
      });

      const prefilled = inputs.find((input) => input.value.trim());
      if (prefilled) syncFromInput(prefilled, true);
    }

    setEngravingFromPersonalization(text, shouldEnable) {
      const engraving = this.querySelector('[data-engraving]');
      const toggle = engraving?.querySelector('[data-engraving-toggle]');
      const field = engraving?.querySelector('[data-engraving-field]');
      const input = engraving?.querySelector('[data-engraving-input]');
      if (!field || !input) return;

      input.value = text || '';
      this.formatEngravingInput(input);
      const formattedText = input.value;
      const normalizedText = this.normalizeEngravingText(input.value);
      const enabled = toggle ? Boolean(shouldEnable || normalizedText) : true;

      engraving.classList.toggle('is-selected', enabled);
      field.hidden = toggle ? !enabled : false;
      if (toggle) {
        toggle.checked = enabled;
        toggle.setAttribute('aria-expanded', enabled ? 'true' : 'false');
      }
      this.state.engraving = { enabled, text: normalizedText };
      this.syncPersonalizationInputs(formattedText);
      this.showError('');
      this.updateView();
    }

    syncPersonalizationInputs(text) {
      const displayText = String(text || '').toUpperCase();

      this.querySelectorAll('[data-personalization-input]').forEach((input) => {
        if (input.value !== displayText) input.value = displayText;
      });
    }

    bindButtons() {
      this.querySelectorAll('[data-add-button], [data-sticky-add]').forEach((button) => {
        button.addEventListener('click', () => this.addToCart());
      });
    }

    bindDoubleToggle() {
      const toggle = this.querySelector('[data-double-toggle]');
      if (!toggle) return;
      toggle.addEventListener('change', () => {
        this.state.double = toggle.checked;
        this.closest('.rco-page')?.classList.toggle('is-double', toggle.checked);
        this.updateView();
        // The closing cards relabel themselves to "Add 2 … Cans" so the choice is never lost.
        document.dispatchEvent(new CustomEvent('rco:double-changed', { detail: { double: toggle.checked } }));
      });
    }

    formatMoney(cents) {
      const value = Math.round(Number(cents) || 0);
      const whole = value % 100 === 0;
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD',
          minimumFractionDigits: whole ? 0 : 2,
          maximumFractionDigits: whole ? 0 : 2
        }).format(value / 100);
      } catch (error) {
        return `$${(value / 100).toFixed(whole ? 0 : 2)}`;
      }
    }

    updateInsuranceNote(cents) {
      const note = this.querySelector('[data-insurance-note]');
      if (!note) return;
      const core = window.SubscriptionInsuranceCore;
      let config = null;
      try { config = core?.getInsuranceConfig?.() || null; } catch (error) { config = null; }
      const enabled = config ? config.enabled : Boolean(window.theme?.shopSettings?.shippingInsuranceEnabled);
      if (!enabled) {
        note.hidden = true;
        return;
      }
      let tier = null;
      try { tier = core?.resolveTierForSubtotal?.(cents, config) || null; } catch (error) { tier = null; }
      const fee = tier && tier.price ? this.formatMoney(tier.price) : '';
      note.textContent = fee
        ? `Covered by shipping protection (${fee}), added at checkout.`
        : 'Covered by shipping protection, added at checkout.';
      note.hidden = false;
    }

    bindCaliberStrip() {
      const strip = this.querySelector('[data-caliber-strip]');
      if (!strip) return;
      const track = strip.querySelector('[data-strip-track]');
      const prev = strip.querySelector('[data-strip-prev]');
      const next = strip.querySelector('[data-strip-next]');
      if (!track) return;
      const step = () => {
        const card = track.querySelector('li');
        return card ? (card.getBoundingClientRect().width + 14) * 2 : 300;
      };
      const sync = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        strip.classList.toggle('is-scrollable', max > 0);
      };
      prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    }

    bindExternalBuy() {
      if (this.externalBuyBound) return;
      this.externalBuyBound = true;
      document.addEventListener('rco:buy', (event) => {
        const detail = event.detail || {};
        const option = Array.from(this.querySelectorAll('[data-package-option]'))
          .find((candidate) => candidate.dataset.variantId === String(detail.variantId));
        if (!option || option.disabled) return;
        detail.handled = true;
        // "Double it?" stays as chosen: the closing cards read "Add 2 … Cans" while it is on.
        this.selectPackage(option);
        if (detail.engraving) this.applyEngraving(detail.engraving);
        const errorEl = this.querySelector('[data-error-message]');
        // The closing cards already compare both tiers: skip the upgrade question.
        this.fromCompare = true;
        this.addToCart().then((status) => {
          this.fromCompare = false;
          if (status === 'ok') return;
          const message = errorEl && !errorEl.hidden ? errorEl.textContent.trim() : '';
          if (message) {
            document.dispatchEvent(new CustomEvent('rco:buy-failed', { detail: { message } }));
          } else {
            // Shopper closed the upsell (or nothing could be added): re-enable the final CTA quietly.
            document.dispatchEvent(new CustomEvent('rco:buy-cancelled'));
          }
        });
      });
    }

    applyEngraving(text) {
      const engraving = this.querySelector('[data-engraving]');
      if (!engraving) return;
      const toggle = engraving.querySelector('[data-engraving-toggle]');
      const input = engraving.querySelector('[data-engraving-input]');
      if (!input) return;
      if (toggle && !toggle.checked) {
        toggle.checked = true;
        toggle.dispatchEvent(new Event('change', { bubbles: true }));
      }
      input.value = text;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    bindFaq() {
      this.querySelectorAll('.rco-faq details').forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          this.querySelectorAll('.rco-faq details').forEach((other) => {
            if (other !== item) other.removeAttribute('open');
          });
        });
      });
    }

    initSticky() {
      this.sticky = this.querySelector('[data-sticky-bar]');
      const target = this.querySelector('[data-add-button]') || this.querySelector('.rco-buy');
      if (!this.sticky || !target || !('IntersectionObserver' in window)) return;

      // Show the bar whenever the main Add button is off screen (above or below).
      // Desktop: only once the shopper has scrolled past the Add button.
      // Phones: also keep it hidden while the tier cards are on screen, so it never covers them.
      const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;
      const grid = this.querySelector('.rco-package-grid');
      const onScreen = (element) => {
        if (!element) return false;
        const rect = element.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      };
      const updateStickyVisibility = () => {
        const rect = target.getBoundingClientRect();
        // Below the fold counts too: a short laptop screen gets an Add button from the first paint.
        const offScreen = rect.bottom < 0 || rect.top > window.innerHeight;
        const gridVisible = !isDesktop() && onScreen(grid);
        const suppressed = this.sticky.classList.contains('is-suppressed');
        const visible = offScreen && !gridVisible && !suppressed;
        this.sticky.classList.toggle('is-visible', visible);
        // Off screen means out of the tab order and the accessibility tree too.
        this.sticky.inert = !visible;
        if (!visible) this.sticky.setAttribute('aria-hidden', 'true');
        else this.sticky.removeAttribute('aria-hidden');
      };
      updateStickyVisibility();

      this.observer = new IntersectionObserver(() => updateStickyVisibility(), { threshold: 0, rootMargin: '0px' });

      this.observer.observe(target);
      if (grid) this.observer.observe(grid);

      const boundary = document.querySelector('.rco-final, .shopify-section-group-footer-group, footer');
      if (!boundary) return;

      this.stickyBoundaryObserver = new IntersectionObserver((entries) => {
        const suppressed = entries.some((entry) => entry.isIntersecting);
        this.sticky.classList.toggle('is-suppressed', suppressed);
        updateStickyVisibility();
      }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });

      this.stickyBoundaryObserver.observe(boundary);
    }

    syncInitialState() {
      // Arrived from the collection with a tier already chosen (?variant=): do not re-ask the upgrade.
      try {
        if (new URLSearchParams(window.location.search).has('variant')) this.state.userPickedTier = true;
      } catch (error) { /* ignore */ }
      const selectedPackage = this.querySelector('[data-package-option].is-selected:not(:disabled)') ||
        this.querySelector('[data-package-option]:not(:disabled)');
      if (selectedPackage) this.readPackage(selectedPackage);
      this.paintPackages(selectedPackage);
      this.updateStack(selectedPackage);
      if (selectedPackage && Array.from(this.querySelectorAll('[data-package-option]')).indexOf(selectedPackage) > 0) {
        this.syncGalleryToTier(selectedPackage);
      } else {
        document.documentElement.dataset.rcoTier = 'range';
        document.dispatchEvent(new CustomEvent('rco:tier', { detail: { tier: 'range' } }));
      }
      if (!this.tierListenerBound) {
        this.tierListenerBound = true;
        document.addEventListener('rco:select-tier', (event) => {
          const want = event.detail && event.detail.tier;
          const options = Array.from(this.querySelectorAll('[data-package-option]'));
          const option = want === 'stock' ? options[1] : options[0];
          if (!option || option.disabled) return;
          this.selectPackage(option);
          const builder = this.querySelector('.rco-step') || this;
          builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      const selectedDelivery = this.querySelector('[data-delivery-option].is-selected:not(:disabled)') ||
        this.querySelector('[data-delivery-option][data-delivery="onetime"]');
      if (selectedDelivery) this.readDelivery(selectedDelivery);
      this.paintDelivery(selectedDelivery);
      this.restoreCollectionEngraving();
    }

    /* A name typed in the collection quick-add rides along to step 2 (and the closing field). */
    restoreCollectionEngraving() {
      const handle = this.dataset.productHandle;
      if (!handle) return;
      const key = `crc-engrave-${handle}`;
      let value = '';
      try {
        value = sessionStorage.getItem(key) || '';
        sessionStorage.removeItem(key);
      } catch (error) {
        return;
      }
      value = String(value).toUpperCase().replace(/[^A-Z0-9 .'&-]/g, '').slice(0, 20).trim();
      if (value) this.applyEngraving(value);
    }

    selectPackage(option) {
      if (!option || option.disabled || this.state.busy) return;
      this.readPackage(option);
      this.paintPackages(option);
      this.updateStack(option);
      this.syncGalleryToTier(option);
      this.updateView();
    }

    syncGalleryToTier(option) {
      const options = Array.from(this.querySelectorAll('[data-package-option]'));
      const stock = options.indexOf(option) > 0;
      document.dispatchEvent(new CustomEvent('rco:tier', { detail: { tier: stock ? 'stock' : 'range' } }));
      document.documentElement.dataset.rcoTier = stock ? 'stock' : 'range';
      const stage = this.querySelector('[data-media-stage-wrap]');
      if (stage) stage.dataset.tier = stock ? 'stock' : 'range';
      const label = stock ? 'Engraved can' : 'Offer';
      const thumb = this.querySelector(`[data-media-thumb][data-media-label="${label}"]`);
      if (thumb) this.selectMedia(thumb);
    }

    updateStack(option) {
      const lists = this.querySelectorAll('[data-stack-tier]');
      if (!lists.length) return;
      const options = Array.from(this.querySelectorAll('[data-package-option]'));
      const index = Math.max(0, options.indexOf(option));
      const tier = index === 0 ? 'range' : 'stock';
      lists.forEach((list) => {
        list.hidden = list.dataset.stackTier !== tier;
      });
    }

    selectDelivery(option) {
      if (!option || option.disabled || this.state.busy) return;
      this.readDelivery(option);
      this.paintDelivery(option);
      this.updateView();
    }

    readPackage(option) {
      this.state.variant = {
        id: option.dataset.variantId || '',
        subscriptionId: option.dataset.subscriptionVariantId || option.dataset.variantId || '',
        title: option.dataset.title || '',
        subscriptionTitle: option.dataset.subscriptionTitle || option.dataset.title || '',
        rounds: option.dataset.rounds || '',
        contents: option.dataset.contents || '',
        upgrade: option.dataset.upgrade || '',
        price: option.dataset.price || '',
        compare: option.dataset.comparePrice || '',
        priceFormatted: option.dataset.priceFormatted || '',
        subscriptionPrice: option.dataset.subscriptionPrice || option.dataset.price || '',
        subscriptionPriceFormatted: option.dataset.subscriptionPriceFormatted || option.dataset.priceFormatted || '',
        available: option.dataset.available === 'true',
        subscriptionAvailable: option.dataset.subscriptionAvailable === 'true'
      };
    }

    readDelivery(option) {
      this.state.delivery = option.dataset.delivery || 'onetime';
      this.state.sellingPlanId = option.dataset.sellingPlanId || '';
    }

    paintPackages(selected) {
      const options = Array.from(this.querySelectorAll('[data-package-option]'));
      const hasActive = options.some((option) => option === selected && !option.disabled);
      options.forEach((option, index) => {
        const active = option === selected && !option.disabled;
        option.classList.toggle('is-selected', active);
        option.setAttribute('aria-checked', active ? 'true' : 'false');
        // Roving tabindex: one Tab stop for the whole radiogroup.
        const focusable = active || (!hasActive && index === 0);
        option.setAttribute('tabindex', focusable ? '0' : '-1');
      });
    }

    paintDelivery(selected) {
      this.querySelectorAll('[data-delivery-option]').forEach((option) => {
        const active = option === selected && !option.disabled;
        option.classList.toggle('is-selected', active);
        option.setAttribute('aria-checked', active ? 'true' : 'false');
      });
    }

    updateView() {
      const variant = this.state.variant || {};
      const isQuarterly = this.state.delivery === 'quarterly' && this.hasSellingPlan;
      const doubled = this.state.double && !isQuarterly;
      const unitCents = Number(variant.price) || 0;
      const doubleCents = Math.round(unitCents * 2 * 0.95);
      const price = doubled
        ? this.formatMoney(doubleCents)
        : (isQuarterly ? variant.subscriptionPriceFormatted : variant.priceFormatted);
      const cta = this.state.busy ? 'Adding…' : this.getCtaLabel(variant, isQuarterly, price, doubled);
      const tierName = this.isStockPackage(variant) ? 'Stock-Up' : 'Range Day';
      // Same anchor as the cards: two cans at compare-at when there is one, else two at today's price.
      const compareCents = Number(variant.compare) || 0;
      const doubleAnchor = compareCents > unitCents ? compareCents * 2 : unitCents * 2;
      this.setText('[data-double-total]', unitCents ? this.formatMoney(doubleCents) : '');
      this.setText('[data-double-compare]', unitCents ? this.formatMoney(doubleAnchor) : '');
      this.setText('[data-double-save]', unitCents ? `Save ${this.formatMoney(doubleAnchor - doubleCents)}` : '');
      this.setText('[data-double-tier]', tierName);
      this.updateInsuranceNote(doubled ? doubleCents : unitCents);

      this.updatePackageCardPrices(isQuarterly);
      this.setText('[data-summary-title]', variant.title || 'Range Can');
      this.setText('[data-summary-contents]', variant.contents || '');
      this.setText('[data-summary-delivery]', isQuarterly ? 'Quarterly Restock' : 'One-time');
      this.setText('[data-summary-price]', price || '');
      this.setText('[data-cta-label]', cta);
      this.querySelectorAll('[data-cta-price]').forEach((element) => {
        element.textContent = '';
        element.hidden = true;
      });
      const stickyBar = this.querySelector('[data-sticky-bar]');
      const shortName = stickyBar?.dataset.productShort || '';
      const tierLabel = `${doubled ? '2× ' : ''}${tierName} Can${doubled ? 's' : ''}`;
      // Phones show the tier only (the product span is hidden under 750px); wider screens show both.
      this.querySelectorAll('[data-sticky-title]').forEach((title) => {
        title.textContent = '';
        if (shortName) {
          const product = document.createElement('span');
          product.className = 'rco-sticky__product';
          product.textContent = `${shortName} · `;
          title.appendChild(product);
        }
        title.appendChild(document.createTextNode(tierLabel));
      });
      const stickyName = this.querySelector('[data-sticky-name]');
      if (stickyName) {
        const name = this.state.engraving.enabled ? this.state.engraving.text : '';
        stickyName.textContent = name ? `Name: ${name}` : 'Free name engraving';
        stickyName.classList.toggle('is-empty', !name);
        stickyName.hidden = false;
      }
      this.setText('[data-sticky-price]', price || '');
      this.setText('[data-sticky-cta]', cta);
      this.updateEngravingSummary();

      const purchaseVariantId = this.getPurchaseVariantId(variant, isQuarterly);
      const purchaseAvailable = isQuarterly ? (variant.subscriptionAvailable || Boolean(purchaseVariantId)) : variant.available;
      const unavailable = !purchaseVariantId || !purchaseAvailable || this.state.busy;
      this.querySelectorAll('[data-add-button], [data-sticky-add]').forEach((button) => {
        button.disabled = unavailable;
        button.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
        button.setAttribute('aria-busy', this.state.busy ? 'true' : 'false');
      });
    }

    updatePackageCardPrices(isQuarterly) {
      this.querySelectorAll('[data-package-option]').forEach((option) => {
        const displayPrice = isQuarterly
          ? (option.dataset.subscriptionPriceFormatted || option.dataset.priceFormatted || '')
          : (option.dataset.priceFormatted || '');
        const price = option.querySelector('[data-package-price]') ||
          option.querySelector('.rco-package__price strong');
        if (price) price.textContent = displayPrice;

        const compare = option.querySelector('[data-package-compare]') ||
          option.querySelector('.rco-package__price s');
        if (!compare) return;

        let comparePrice = option.dataset.comparePriceFormatted || '';
        if (isQuarterly) {
          const regularPrice = Number(option.dataset.price) || 0;
          const subscriptionPrice = Number(option.dataset.subscriptionPrice) || 0;
          comparePrice = regularPrice > 0 && subscriptionPrice > 0 && subscriptionPrice < regularPrice
            ? (option.dataset.priceFormatted || '')
            : '';
        }

        compare.textContent = comparePrice;
        compare.hidden = !comparePrice;
      });
    }

    getCtaLabel(variant, isQuarterly, price, doubled) {
      const displayPrice = price || (isQuarterly ? variant.subscriptionPriceFormatted : variant.priceFormatted) || '';

      if (isQuarterly) {
        return `Start Quarterly Restock${displayPrice ? ` • ${displayPrice}` : ''}`;
      }

      // Same tier names as the cards, sticky bar and closing cards (no round counts on the button).
      const tier = this.isStockPackage(variant) ? 'Stock-Up' : 'Range Day';
      const packageLabel = doubled ? `2 ${tier} Cans` : `${tier} Can`;
      return `Add ${packageLabel}${displayPrice ? ` • ${displayPrice}` : ''}`;
    }

    async runUpsell() {
      if (this.upsellResolved || !window.RangeCanUpsell || this.state.double) return 'skip';
      const node = document.querySelector('[data-rco-upsell]');
      if (!node) return 'skip';
      let data;
      try { data = JSON.parse(node.textContent); } catch (e) { return 'skip'; }
      if (!data || data.enabled === false) return 'skip';
      const current = this.state.variant || {};
      const tier = this.isStockPackage(current) ? 'stock' : 'range';
      // Before the add, only the untouched Range Day default gets one question: upgrade to Stock-Up?
      // The second-can offer comes after the add, on the confirmation sheet.
      if (this.state.userPickedTier || this.fromCompare || tier === 'stock') return 'skip';
      const result = await window.RangeCanUpsell.prompt({
        ...data,
        tier,
        // Range Day was chosen on purpose (card tap or closing compare): offer a second can, not the upgrade again.
        skipUpgrade: Boolean(this.state.userPickedTier || this.fromCompare),
        engraving: this.getEngravingSelection().text || '',
        pairDiscount: Boolean(data.pairDiscount),
        suggestions: Array.isArray(data.suggestions) ? data.suggestions : []
      });
      // A name typed on the sheet rides along like one typed in step 2.
      if (result && result.engraving) this.applyEngraving(result.engraving);
      // Closed with X / Escape / scrim: stay on the page, ask again next time.
      if (result && result.cancelled) return 'cancelled';
      this.upsellResolved = true;
      this.extraItems = (result && result.extraItems) || [];
      if (result && result.variantId && String(result.variantId) !== String(current.id)) {
        const option = Array.from(this.querySelectorAll('[data-package-option]'))
          .find((candidate) => candidate.dataset.variantId === String(result.variantId));
        if (option) this.selectPackage(option);
      }
      return 'done';
    }

    validateEngraving() {
      const engraving = this.getEngravingSelection();
      const input = this.querySelector('[data-engraving-input]');
      if (!this.querySelector('[data-engraving-toggle]')) return true;
      if (!engraving.enabled || engraving.text || !input) return true;
      this.showError('Add the name to engrave, or uncheck engraving.');
      input.setAttribute('aria-invalid', 'true');
      const field = this.querySelector('[data-engraving-field]');
      if (field) field.hidden = false;
      input.focus({ preventScroll: true });
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }

    async addToCart() {
      if (!this.state.variant || this.state.busy) return 'skip';
      if (!this.validateEngraving()) return 'error';
      // One sheet per add: the Stock-Up upgrade and second-can offers live on the after-add
      // confirmation (RangeCanUpsell.confirm), so nothing interrupts before the add.

      const variant = this.state.variant;
      if (!variant || this.state.busy) return 'skip';

      const isQuarterly = this.state.delivery === 'quarterly' && this.hasSellingPlan;
      const purchaseVariantId = this.getPurchaseVariantId(variant, isQuarterly);
      const purchaseAvailable = isQuarterly ? (variant.subscriptionAvailable || Boolean(purchaseVariantId)) : variant.available;

      if (!purchaseVariantId || !purchaseAvailable) return 'skip';

      if (this.state.delivery === 'quarterly' && (!this.hasSellingPlan || !this.state.sellingPlanId || !purchaseVariantId)) {
        this.showError('Quarterly delivery is not available yet.');
        return 'error';
      }

      const engraving = this.getEngravingSelection();
      const item = {
        id: Number(purchaseVariantId),
        quantity: this.state.double && !isQuarterly ? 2 : 1,
        properties: {
          Package: variant.title,
          Delivery: isQuarterly ? 'Quarterly Range Can' : 'One-time purchase'
        }
      };

      if (engraving.enabled && engraving.text) {
        item.properties['Custom Name Engraving'] = engraving.text;
        item.properties['Engraving Placement'] = this.isStockPackage(variant)
          ? 'Below the design on both cans'
          : 'Below We The People engraving';
      }

      if (isQuarterly) item.selling_plan = Number(this.state.sellingPlanId);

      this.setBusy(true);
      this.showError('');

      try {
        const items = [item];
        if (this.extraItems && this.extraItems.length) {
          // Every extra range can carries the same free name engraving as the first.
          items.push(...this.extraItems.map((extra) => {
            if (!(engraving.enabled && engraving.text)) return extra;
            return {
              ...extra,
              properties: {
                ...(extra.properties || {}),
                'Custom Name Engraving': engraving.text,
                'Engraving Placement': String(extra.id) === String(variant.id) && this.isStockPackage(variant)
                  ? 'Below the design on both cans'
                  : 'Below We The People engraving'
              }
            };
          }));
        }
        const insuranceItem = await this.getInsuranceCartItem(isQuarterly);
        if (insuranceItem) items.push(insuranceItem);

        const response = await fetch(`${this.getRoot()}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || error.message || 'Unable to add this Range Can.');
        }

        window.SubscriptionInsuranceCore?.clearCartCache?.();
        // 'confirm' (not 'ok'): the shopper is still on the page, so callers re-enable their buttons.
        if (await this.showConfirmation(variant, engraving)) return 'confirm';
        window.location.href = this.redirectUrl;
        return 'ok';
      } catch (error) {
        this.showError(error.message || 'Unable to add this Range Can.');
        this.setBusy(false);
        return 'error';
      }
    }

    /* After a one-time add: show the confirmation sheet (second-can offers + continue to checkout)
       instead of jumping straight to checkout. Returns false when it can't show, so the caller
       redirects as before. */
    async showConfirmation(variant, engraving) {
      if (!window.RangeCanUpsell || !window.RangeCanUpsell.confirm) return false;
      let data;
      try { data = JSON.parse(document.querySelector('[data-rco-upsell]').textContent); } catch (e) { return false; }
      if (!data || !Array.isArray(data.products)) return false;
      const product = data.products.find((p) => p.handle === data.handle) || { handle: data.handle, title: data.title, tags: data.tags || [], variants: [] };
      const picked = (product.variants || []).find((v) => String(v.id) === String(variant.id))
        || { id: variant.id, title: variant.title, price: '', cents: 0, available: true };
      let cans = 1;
      try { cans = await window.RangeCanUpsell.rangeCanCount(data.products); } catch (e) { /* assume one */ }
      this.setBusy(false);
      window.RangeCanUpsell.confirm({
        product,
        products: data.products,
        pickedVariant: picked,
        isStock: this.isStockPackage(variant),
        engraving: engraving.enabled && engraving.text ? engraving.text : '',
        pairDiscount: Boolean(data.pairDiscount),
        cans,
        checkoutUrl: this.redirectUrl
      });
      return true;
    }

    getPurchaseVariantId(variant, isQuarterly) {
      if (!isQuarterly) return variant.id || '';
      if (this.isStockPackage(variant) && this.stockRestockVariantId) return this.stockRestockVariantId;
      if (!this.isStockPackage(variant) && this.rangeRestockVariantId) return this.rangeRestockVariantId;
      return variant.subscriptionId || variant.id || '';
    }

    isStockPackage(variant) {
      const text = [
        variant.id,
        variant.title,
        variant.rounds,
        variant.contents,
        variant.upgrade
      ].join(' ').toLowerCase();

      return text.includes('stock') ||
        text.includes('2,250') ||
        text.includes('2250') ||
        text.includes('1,200') ||
        text.includes('1200') ||
        variant.id === '51409345839399';
    }

    getEngravingSelection() {
      const toggle = this.querySelector('[data-engraving-toggle]');
      const input = this.querySelector('[data-engraving-input]');
      if (!input) {
        this.state.engraving = { enabled: false, text: '' };
        return this.state.engraving;
      }

      const enabled = toggle ? Boolean(toggle.checked) : true;
      if (input) this.formatEngravingInput(input);
      const text = this.normalizeEngravingText(input?.value || this.state.engraving.text || '');
      this.state.engraving = { enabled, text };
      return this.state.engraving;
    }

    formatEngravingInput(input) {
      if (!input) return;

      const upper = String(input.value || '').toUpperCase();
      // Letters, numbers, spaces and . ' & - engrave cleanly; drop anything else (emoji, symbols).
      const formatted = upper.replace(/[^A-Z0-9 .'&-]/g, '');
      if (input.matches && input.matches('[data-engraving-input]')) this.updateEngravingMeta(input, formatted, formatted !== upper);
      if (input.value === formatted) return;

      const selectionStart = input.selectionStart;
      const selectionEnd = input.selectionEnd;
      input.value = formatted;

      if (document.activeElement === input && selectionStart !== null && selectionEnd !== null) {
        input.setSelectionRange(selectionStart, selectionEnd);
      }
    }

    updateEngravingMeta(input, value, stripped) {
      const max = Number(input.getAttribute('maxlength')) || 20;
      const count = this.querySelector('[data-engraving-count]');
      if (count) count.textContent = `${value.length}/${max}`;
      const preview = this.querySelector('[data-engraving-preview]');
      if (!preview) return;
      const text = this.normalizeEngravingText(value);
      if (stripped) {
        preview.textContent = 'Letters, numbers, spaces and . \' & - only.';
        preview.hidden = false;
      } else {
        preview.textContent = text ? `Engraves as: ${text}` : '';
        preview.hidden = !text;
      }
    }

    normalizeEngravingText(value) {
      return String(value || '').replace(/\s+/g, ' ').trim().toUpperCase();
    }

    updateEngravingSummary() {
      const summary = this.querySelector('[data-summary-engraving]');
      if (!summary) return;

      const engraving = this.getEngravingSelection();
      if (!engraving.enabled) {
        summary.hidden = true;
        summary.textContent = '';
        return;
      }

      summary.hidden = !engraving.text;
      summary.textContent = engraving.text ? `Engraving: ${engraving.text}` : '';
    }

    async getInsuranceCartItem(isSubscription) {
      try {
        if (window.SubscriptionInsuranceCore) {
          const insuranceAction = await window.SubscriptionInsuranceCore.determineInsuranceAction(
            isSubscription,
            isSubscription ? this.sellingPlanFrequency : null
          );

          return await window.SubscriptionInsuranceCore.executeInsuranceAction(insuranceAction);
        }
      } catch (error) {
        console.warn('[Range Can] Insurance check failed, using fallback:', error);
      }

      return this.getFallbackInsuranceItem(isSubscription);
    }

    getFallbackInsuranceItem(isSubscription) {
      const settings = window.theme?.shopSettings || {};
      const variantId = Number(settings.shippingInsuranceVariantId);
      if (!settings.shippingInsuranceEnabled || !variantId) return null;

      const item = {
        id: variantId,
        quantity: 1
      };

      if (isSubscription) {
        const plans = settings.insuranceSellingPlans || {};
        const sellingPlanId = plans[this.sellingPlanFrequency] ||
          plans[90] ||
          plans['90'] ||
          Object.values(plans).find(Boolean);
        const parsedSellingPlanId = Number(sellingPlanId);

        if (sellingPlanId) {
          item.selling_plan = Number.isNaN(parsedSellingPlanId) ? sellingPlanId : parsedSellingPlanId;
        }
      }

      return item;
    }

    getRoot() {
      return window.Shopify?.routes?.root || '/';
    }

    normalizeRedirectUrl(url) {
      const redirectUrl = (url || '/checkout').trim();
      if (!redirectUrl || /^\/?cart\/?$/i.test(redirectUrl)) return '/checkout';
      return redirectUrl;
    }

    setBusy(isBusy) {
      if (isBusy) RangeCanOffer.hideCartDrawer();
      this.state.busy = isBusy;
      this.classList.toggle('is-busy', isBusy);
      this.updateView();
    }

    showError(message) {
      const error = this.querySelector('[data-error-message]');
      const stickyError = this.querySelector('[data-sticky-error]');
      if (stickyError) {
        stickyError.textContent = message || '';
        stickyError.hidden = !message;
      }
      if (!error) return;
      error.textContent = message || '';
      error.hidden = !message;
      if (!message) return;
      // A sticky-bar or sheet tap can leave the message off screen: bring it into view.
      const rect = error.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight) {
        error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    /* The UpCart app opens its drawer on every cart/add.js call. These buttons go straight to
       checkout, so the drawer stays hidden from the first add until the shopper opens the cart. */
    static hideCartDrawer() {
      const root = document.documentElement;
      if (root.classList.contains('rco-adding')) return;
      root.classList.add('rco-adding');
      const release = (event) => {
        const target = event.target && event.target.closest
          ? event.target.closest('a[href*="/cart"], [href="#cart"], .header__icon--cart, [data-cart-toggle], [aria-controls*="cart" i]')
          : null;
        if (!target || target.closest('.rco-page')) return;
        root.classList.remove('rco-adding');
        document.removeEventListener('click', release, true);
      };
      document.addEventListener('click', release, true);
    }

    setText(selector, value) {
      this.querySelectorAll(selector).forEach((element) => {
        element.textContent = value || '';
      });
    }
  });
})();
